<template>
  <div class="player">
    <span id="t-add-up">
      <TransmissionsAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="atualizar"
        :page="0"
        :titleCard="'create'"
        :updateData="null"
      />
    </span>
    <va-card :title="$t('dashboard.player')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#t-add-up"
        />
      </template>
      <iframe
        v-if="transmission.length > 0"
        type="iframe"
        aspect="16by9"
        class="embed-responsive"
        :src="'https://www.youtube.com/embed/'+ transmission[0].url"
        allowfullscreen
      ></iframe>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import TransmissionsAddUpdate from '../../transmissions/TransmissionsAddUpdate'
export default {
  name: 'player',
  components: {
    TransmissionsAddUpdate,
  },
  data () {
    return {
      transmission: [],
      showAdd: false,
    }
  },
  apollo: {
    transmission: gql`
    query MyQuery {
      transmission(limit: 1, order_by: {id: desc}) {
        url
      }
    }
    `,
  },
  methods: {
    close (v) {
      this.showAdd = v
    },
    open () {
      this.showAdd = true
    },
    atualizar (a) {
      this.$apollo.queries.transmission.refetch()
    },
  },
}
</script>

<style>
.frame {
  width: 100% !important;
  height: 100% !important;
}

.embed-responsive {
  min-height: 500px !important;
  height: 100% !important;
  width: 100% !important;
}
</style>
